import {
  Fieldset
} from "./chunk-Z2ZPTZ6F.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/form/radio-button/radio-group.tsx
import {
  createContext,
  forwardRef,
  useContext
} from "react";
import { jsx } from "react/jsx-runtime";
var RadioGroupContext = createContext({
  name: void 0,
  hasError: false,
  onChange: () => {
    return void 0;
  }
});
var useRadioGroupContext = () => useContext(RadioGroupContext);
var RadioGroup = forwardRef(function RadioGroup2(_a, ref) {
  var _b = _a, { name, value, errorMessage, onChange, children } = _b, rest = __objRest(_b, ["name", "value", "errorMessage", "onChange", "children"]);
  return /* @__PURE__ */ jsx(RadioGroupContext.Provider, { value: { name, value, hasError: Boolean(errorMessage), onChange }, children: /* @__PURE__ */ jsx(Fieldset, __spreadProps(__spreadValues({ errorMessage }, rest), { ref, children })) });
});
RadioGroup.displayName = "RadioGroup";

export {
  useRadioGroupContext,
  RadioGroup
};
//# sourceMappingURL=chunk-E6OOFTRQ.mjs.map